import Api from "./api";

interface props {
    codeStore: string,
    password: string
}

export const loginUserByAPI = async (props: props) => {
    const reqUrl = "/login";
    const res = await Api.post(reqUrl, props);
    return res.data;
};